import { render, staticRenderFns } from "./RibbonDocument.vue?vue&type=template&id=43715304&scoped=true"
import script from "./RibbonDocument.vue?vue&type=script&lang=js"
export * from "./RibbonDocument.vue?vue&type=script&lang=js"
import style0 from "./RibbonDocument.vue?vue&type=style&index=0&id=43715304&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43715304",
  null
  
)

export default component.exports